import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { UnidadeService } from 'src/app/services/http/unidade.service';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';

@Component({
  selector: 'app-form-tipo-unidade',
  templateUrl: './form-tipo-unidade.component.html',
  styleUrls: ['./form-tipo-unidade.component.scss']
})
export class FormTipoUnidadeComponent implements OnInit {

  form = new FormGroup({
    nome: new FormControl('', [Validators.required]),
    descricao: new FormControl('', []),
    nivel: new FormControl('1', [Validators.required]),
  });

  tipoUnidade = null;

  desativar = false;
  id = null;
  numberMask = {guide: false, mask: [/\d/]};
  cliente:boolean = false;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private modalService: NgbModal, private modalMsgService: ModalMsgService, private unidadeService: UnidadeService) {
    this.cliente = this.activatedRoute.snapshot.data.id;
    this.id = this.activatedRoute.snapshot.params.id;

    if (this.id) this.unidadeService.getListaTipoUnidade().then(r => {
      this.tipoUnidade = r.filter(v => v.id == this.id)[0];
      this.form.patchValue(this.tipoUnidade);
      this.desativar = this.tipoUnidade.desabilitado;
    });

  }

  ngOnInit() {
  }

  concluir() {

    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = this.id ? 'Editar tipo unidade' : 'Adicionar tipo unidade';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        if (this.id) {
          this.unidadeService.editarTipoUnidade({
            ...this.form.value, desabilitado: this.desativar, id: this.id
          }, justificativa)
            .then(r => this.modalMsgService.openDialog('Dados alterados com sucesso', '', 'success')
              .finally(() => this.router.navigate(['unidade','tipo','listar']))
            ).catch(result => this.modalMsgService.openDialog('Erro ao efetuar transação',
              'Ocorreu um erro ao se comunicar com a base de dados, tente novamente mais tarde, ou entre contato com o responsável', 'danger'));
        } else {
          this.unidadeService.adicionarTipoUnidade({
            ...this.form.value,
          }, justificativa)
            .then(r => this.modalMsgService.openDialog('Dados alterados com sucesso', '', 'success')
              .finally(() => this.router.navigate(['unidade','tipo','listar']))
            ).catch(result => this.modalMsgService.openDialog('Erro ao efetuar transação',
              'Ocorreu um erro ao se comunicar com a base de dados, tente novamente mais tarde, ou entre contato com o responsável', 'danger'));
        }
      } else {
        this.modalMsgService.openDialog('Erro ao efetuar transação', 'Nenhuma justificativa foi informada', 'danger');
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao efetuar transação', 'Nenhuma justificativa foi informada', 'danger'));
    
  }

}
